import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { AmplifyConfigService } from './modules/shared/services/amplify-config.service';

export interface AwsConfig {
  graphqlEndpoint: string;
  graphqlRegion: string;
  defaultAuthMode: string;
}

export const getAwsConfigForHostname = (hostname: string): AwsConfig => {
  const awsConfig: AwsConfig = {
    graphqlEndpoint: '',
    graphqlRegion: 'us-east-1',
    defaultAuthMode: 'lambda'
  };

  if (hostname.includes('dev.dealer') || hostname.includes('localhost')) {
    awsConfig.graphqlEndpoint = 'https://dxra-as-events-api.dev.dealer.toyota.com/graphql';
  } else if (hostname.includes('test.dealer')) {
    awsConfig.graphqlEndpoint = 'https://dxra-as-events-api.test.dealer.toyota.com/graphql';
  } else if (hostname.includes('qa.dealer')) {
    awsConfig.graphqlEndpoint = 'https://dxra-as-events-api.qa.dealer.toyota.com/graphql';
    awsConfig.graphqlRegion = 'us-west-2';
  } else if (hostname.includes('stage.dealer')) {
    awsConfig.graphqlEndpoint = 'https://dxra-as-events-api.stage.dealer.toyota.com/graphql';
  } else if (hostname.includes('dealer')) {
    awsConfig.graphqlEndpoint = 'https://dxra-as-events-api.dealer.toyota.com/graphql';
  }

  return awsConfig;
};

const awsConfig = getAwsConfigForHostname(window.location.hostname);
const amplifyConfigService = new AmplifyConfigService();
amplifyConfigService.configureAmplify(awsConfig);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Toyota Dealership';

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.renderer.addClass(this.document.body, 'asp-dealer-app');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'asp-dealer-app');
  }
}
